module.exports = __webpack_public_path__ + "static/media/deleteConvo.dcca406a.svg";